const pushAssignment = ({ selectedAssignments, assignmentId }) => [
  ...selectedAssignments,
  { id: assignmentId },
];

export default pushAssignment;
